<template>
	<div v-if="isTestMode" class="height-100">
		<WidgetEditHeader @show-preview="onPreview" @edit-structure="onEditStructure" :hasEditPermissions="hasEditPermissions" />
		<div class="content-and-footer-container width-100 display-flex flex-column flex-justify-space-between flex-align-center">
			<SetupMenu class="content-menu-container" @edit-structure="onEditStructure" :configurationIds="configurationIds" />
			<WidgetTestFooter @hide-widget="onEditStructure" />
		</div>
	</div>
	<ConfigurationEditor v-else-if="isEditMode" @show-preview="onPreview" @switch-to-test-mode="switchToTestMode" />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SetupMenu from '@/views/Flow/configurations/SetupMenu';
import { DRAWER_MODES } from '@/store/modules/leftSideDrawer/state';
import WidgetEditHeader from '@/components/BlockEditorWidget/WidgetEditHeader';
import WidgetTestFooter from '@/components/BlockEditorWidget/WidgetTestFooter';
import { setLeftSideDrawerState } from '@/store/modules/leftSideDrawer/actions';
import ConfigurationEditor from '@/views/Flow/configurations/ConfigurationEditor';
import WorkflowConfigurationResponseService from '@/utils/workflow-configuration-response-service';
import { generalConfigurationId, userSpecificConfigurationId } from '@/store/modules/configurationEditor/getters';
import { leftSideDrawerState, isLeftDrawerTestMode, isLeftDrawerEditMode } from '@/store/modules/leftSideDrawer/getters';
export default {
	name: 'InstallableModuleSetupEditor',
	components: {
		SetupMenu,
		WidgetEditHeader,
		WidgetTestFooter,
		ConfigurationEditor,
	},
	props: {
		hasEditPermissions: { type: Boolean },
	},
	computed: {
		...mapGetters([
			leftSideDrawerState.fullPath,
			isLeftDrawerEditMode.fullPath,
			isLeftDrawerTestMode.fullPath,
			generalConfigurationId.fullPath,
			userSpecificConfigurationId.fullPath,
		]),
		sideBarMode() {
			return this[leftSideDrawerState.fullPath];
		},
		isTestMode() {
			return this[isLeftDrawerTestMode.fullPath];
		},
		isEditMode() {
			return this[isLeftDrawerEditMode.fullPath];
		},
		configurationIds() {
			return {
				generalConfigurationId: this[generalConfigurationId.fullPath],
				userSpecificConfigurationId: this[userSpecificConfigurationId.fullPath],
			};
		},
	},
	methods: {
		...mapActions([setLeftSideDrawerState.fullPath]),
		onEditStructure() {
			this[setLeftSideDrawerState.fullPath](DRAWER_MODES.edit);
		},
		async onPreview() {
			if (this[generalConfigurationId.fullPath] || this[userSpecificConfigurationId.fullPath]) {
				await WorkflowConfigurationResponseService.editAndSaveConfiguration();
			}
		},
		switchToTestMode() {
			this[setLeftSideDrawerState.fullPath](DRAWER_MODES.test);
		},
	},
};
</script>

<style scoped lang="scss">
.content-and-footer-container {
	height: calc(100% - 66px);
	background: var(--configuration-background);
}
.content-menu-container {
	margin-top: 55px;
}
</style>
